import { Routes } from '@angular/router';
import { sysLoginGuard } from './sys-login/sys-login.guard';

export const routes: Routes = [
    {
        path: 'home',
        canActivate: [sysLoginGuard],         
        loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadComponent: () => import('./home/start/home-start.component').then(c => c.HomeStartComponent)
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./dashboard/dashboard.component').then(c => c.DashboardComponent)
            },
            { 
                path: 'centro-de-custos', 
                loadComponent: () => import('./entities/cost_center/cost_center.component').then(c => c.CostCenterComponent) 
            },
            { 
                path: 'clientes', 
                loadComponent: () => import('./entities/client/client.component').then(c => c.ClientComponent) 
            },
            { 
                path: 'cheques', 
                loadComponent: () => import('./entities/received_check/received_check.component').then(c => c.ReceivedCheckComponent) 
            },
            {
                path: 'classes-clientes',
                loadComponent: () => import('./entities/client_category/client_category.component').then(c => c.ClientCategoryComponent)
            },
            {
                path: 'convenios',
                loadComponent: () => import('./entities/client_agreement/client_agreement.component').then(c => c.ClientAgreementComponent)
            },
            {
                path: 'contas',
                loadComponent: () => import('./entities/account/account.component').then(c => c.AccountComponent)
            },
            {
                path: 'classes-produtos',
                loadComponent: () => import('./entities/product_category/product_category.component').then(c => c.ProductCategoryComponent)
            },
            {
                path: 'classificacao-fiscal',
                loadComponent: () => import('./entities/tax_category/tax_category.component').then(c => c.TaxCategoryComponent)
            },
            {
                path: 'emprestimos',
                loadComponent: () => import('./entities/product_loans/product_loans.component').then(c => c.ProductLoansComponent)
            },
            {
                path: 'extrato/:account_ulid',
                loadComponent: () => import('./statement/statement.component').then(c => c.StatementComponent)                
            },
            {
                path: 'extrato',
                loadComponent: () => import('./statement/statement.component').then(c => c.StatementComponent)
            },            
            {
                path: 'faturas',
                loadComponent: () => import('./entities/invoices/invoices.component').then(c => c.InvoicesComponent)
            },
            {
                path: 'faturamento',
                loadComponent: () => import('./entities/general_invoices_batch/general_invoices_batch.component').then(c => c.GeneralInvoicesBatchComponent)
            },
            {
                path: 'fornecedores',
                loadComponent: () => import('./entities/supplier/supplier.component').then(c => c.SupplierComponent)
            },
            {
                path: 'funcionarios',
                loadComponent: () => import('./entities/employee/employee.component').then(c => c.EmployeeComponent)
            },
            {
                path: 'controle-interno',
                loadComponent: () => import('./payroll/payroll.component').then(c => c.PayrollComponent)
            },
            {
                path: 'verbas',
                loadComponent: () => import('./entities/payroll_item_type/payroll_item_type.component').then(c => c.PayrollItemTypeComponent)
            },            
            {
                path: 'historicos-de-caixa',
                loadComponent: () => import('./entities/cashier_history/cashier_history.component').then(c => c.CashierHistoryComponent)
            },
            {
                path: 'forma-de-pagamento',
                loadComponent: () => import('./entities/payment_method/payment_method.component').then(c => c.PaymentMethodComponent)
            },
            {
                path: 'ncm',
                loadComponent: () => import('./entities/sys_ncm/sys_ncm.component').then(c => c.SysNcmComponent)
            },
            {
                path: 'pedidos',
                loadComponent: () => import('./orders/orders.component').then(c => c.OrdersComponent),
            },
            {
                path: 'pedidos/pedido',
                loadComponent: () => import('./orders/order/order.component').then(c => c.OrderComponent),
                canDeactivate: [(component: any) => component.canDeactivate ? component.canDeactivate() : true]
            },
            {
                path: 'pedidos/pedido/:order_id',
                loadComponent: () => import('./orders/order/order.component').then(c => c.OrderComponent),
                canDeactivate: [(component: any) => component.canDeactivate ? component.canDeactivate() : true]
            },
            {
                path: 'planos-de-pagamento',
                loadComponent: () => import('./entities/payment_plan/payment_plan.component').then(c => c.PaymentPlanComponent)
            },
            {
                path: 'produtos',
                loadComponent: () => import('./entities/product/product.component').then(c => c.ProductComponent)
            },
            {
                path: 'regioes',
                loadComponent: () => import('./entities/client_region/client_region.component').then(c => c.ClientRegionComponent)
            },
            {
                path: 'transportadoras',
                loadComponent: () => import('./entities/carrier/carrier.component').then(c => c.CarrierComponent)
            },
            {
                path: 'unidades-de-medida',
                loadComponent: () => import('./entities/sys_unit_of_measure/sys_unit_of_measure.component').then(c => c.SysUnitOfMeasureComponent)
            },
            {
                path: 'usuarios',
                loadComponent: () => import('./entities/user_app/user_app.component').then(c => c.UserAppComponent)
            },
            {
                path: 'vendedores',
                loadComponent: () => import('./entities/seller/seller.component').then(c => c.SellerComponent)
            },
            {
                path: 'relatorios',
                loadComponent: () => import('./reports/reports.component').then(c => c.ReportsComponent)
            },
            {
                path: 'relatorios/gerador',
                loadComponent: () => import('./report-builder/report-builder.component').then(c => c.ReportBuilderComponent)
            },
            {
                path: 'relatorios/gerador/:sys_report_ulid',
                loadComponent: () => import('./report-builder/report-builder.component').then(c => c.ReportBuilderComponent)
            },
            {
                path: 'relatorios/categoria/:categoryName',
                loadComponent: () => import('./reports/reports.component').then(c => c.ReportsComponent)
            },
            {
                path: 'relatorios/editor',
                loadComponent: () => import('./report-editor/report-editor.component').then(c => c.ReportEditorComponent)
            },
            {
                path: 'relatorios/cadastro',
                loadComponent: () => import('./entities/sys_report/sys_report.component').then(c => c.SysReportComponent)
            },
            {
                path: 'producao/fornos',
                loadComponent: () => import('./production/kiln/kiln.component').then(c => c.KilnComponent)
            },
            {
                path: 'producao/emprestados',
                loadComponent: () => import('./production/borrowed/borrowed.component').then(c => c.BorrowedComponent)
            },
            {
                path: 'producao/cavacos',
                loadComponent: () => import('./production/wood_chip/wood_chip.component').then(c => c.WoodChipComponent)
            },
            {
                path: 'producao/carregamentos',
                loadComponent: () => import('./production/cargo_delivery/cargo_delivery.component').then(c => c.CargoDeliveryComponent)
            },
            {
                path: 'producao/ordens',
                loadComponent: () => import('./production/production_orders/production_orders.component').then(m => m.ProductionOrderComponent)
            },
            {
                path: 'producao/ordens/nova',
                redirectTo: 'producao/ordens',
                pathMatch: 'full'
            },
            {
                path: 'parametros',
                loadComponent: () => import('./parameters/parameters.component').then(c => c.ParametersComponent)
            },
            {
                path: 'dados-da-ceramica',
                loadComponent: () => import('./company-data/company-data.component').then(c => c.CompanyDataComponent)
            }
        ]
    },
    { 
        path: 'acesso', 
        loadComponent: () => import('./sys-login/sys-login.component').then(c => c.SysLoginComponent) 
    },
    {
        path: 'redefinir-senha',
        loadComponent: () => import('./sys-login/reset-password/reset-password.component').then(c => c.ResetPasswordComponent)
    },
    {
        path: '**',
        redirectTo: 'home'
    }
];
